/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import bitmap from "../../assets/images/pictures/bitmap.png";
// import e_residency_logo from "../../assets/images/pictures/e-residency-logo.png"
import ic_gopaperless from "../../assets/images/pictures/icon/ic_gopaperless.svg";
import view from "../../assets/images/pictures/view.png";
import ic_flash from "../../assets/images/pictures/icon/ic-flash-on-gradient-24-px.svg";
import ic_phone_link from "../../assets/images/pictures/icon/ic-phonelink-gradient-24-px.svg";
import ic_trending from "../../assets/images/pictures/icon/ic-trending-up-gradient-24-px.svg";
import ic_shield from "../../assets/images/pictures/icon/ic-security-gradient-24-px.svg";
import ic_assignment from "../../assets/images/pictures/icon/ic-assignment-turned-in-gradient-46-px.svg";
import ic_code from "../../assets/images/pictures/icon/ic-code-gradient-46-px.svg";
import iso from "../../assets/images/compliance/iso-ias-new.png";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "../../components/global/Footer";
import NavbarBottom from "../../components/global/NavbarBottom";
import { useTranslation } from "react-i18next";

const EResidencyContent = () => {
  const { t, i18n } = useTranslation();
  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="container mt-50">
        <div className="row">
          <div className="col-md-6 px-md-0">
            <h2 className="font-weight-bold font-48 pr-50">
              {t("e-residency.title")}
            </h2>
            <p className="mb-25 mt-25">{t("e-residency.note1")}</p>
            <a
              id="button-start-free-en"
              href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                i18n.language || "vi"
              }`}
              target="_blank"
              rel="noreferrer"
              className="btn-secondary mb-40"
            >
              {t("e-residency.button1")}
            </a>
          </div>
          <div className="col-md-6 pr-md-0">
            <img
              src={bitmap}
              className="img-responsive"
              alt="E-residents"
              decoding="async"
              loading="lazy"
            />
          </div>
        </div>
      </div>

      {/* <div className="container px-md-0 mt-50">
                <div className="row" id="intro">
                    <div className="col col-md-5">
                        <img src={e_residency_logo} alt="logo" />
                    </div>
                    <div className="col col-md-7">
                        <p className='font-14'>The Republic of Estonia is the first country to offer e-Residency — a transnational digital identity available to anyone in the world. e-Residency enables secure and convenient digital services that facilitate credibility and trust online. e-Residents receive a smart ID card which provides the ability to use it for document signing, verification, encryption, and secure identification.</p>
                    </div>
                </div>
            </div> */}
      <div className="bg-color mt-50">
        <div className="container">
          <div className="row" id="paperless">
            <div className="col-md-8 col-md-offset-2 text-center">
              <img
                width="64"
                src={ic_gopaperless}
                data-no-retina=""
                alt="GoPaperless"
              />
              <h2 className="font-weight-bold">{t("e-residency.note2")}</h2>
              <p className="subhead">{t("e-residency.note3")}</p>
            </div>
            <div className="col-xs-12 text-center">
              <img src={view} alt="document example"       className="img-responsive" />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row" id="reasons">
          <div className="col-md-3 px-md-0">
            <img
              width="24px"
              height="24px"
              src={ic_flash}
              data-no-retina=""
              alt="ic_flash"
            />
            <h2 className="font-weight-bold ">{t("e-residency.note4")}</h2>
            <p className="text-lg-mw-210">{t("e-residency.note5")}</p>
          </div>
          <div className="col-md-3 px-md-0">
            <img
              width="24px"
              height="24px"
              src={ic_phone_link}
              data-no-retina=""
              alt="ic_phone_link"
            />
            <h2 className="font-weight-bold ">{t("e-residency.note6")}</h2>
            <p className="text-lg-mw-210">{t("e-residency.note7")}</p>
          </div>
          <div className="col-md-3 px-md-0">
            <img
              width="24px"
              height="24px"
              src={ic_trending}
              data-no-retina=""
              alt="ic_trending"
            />
            <h2 className="font-weight-bold ">{t("e-residency.note8")}</h2>
            <p className="text-lg-mw-210">{t("e-residency.note9")}</p>
          </div>
          <div className="col-md-3 px-md-0">
            <img
              width="24px"
              height="24px"
              src={ic_shield}
              data-no-retina=""
              alt="ic_shield"
            />
            <h2 className="font-weight-bold ">{t("e-residency.note10")}</h2>
            <p className="text-lg-mw-210">{t("e-residency.note11")}</p>
          </div>
        </div>
      </div>

      <div className="container px-md-0">
        <hr />
      </div>

      <div className="border-bottom bg-color white p-md-0">
        <div className="container p-md-0">
          <div className="row isign-apis">
            <div className="col-md-5">
              <h2 className="text-get-started font-weight-bold">
                {t("e-residency.note12")}
              </h2>
              <h4 className="text-p">{t("e-residency.note13")}</h4>
            </div>
            <div className="col-sm-12 col-md-7">
              <div className="btn-box">
                <a
                  id="button-start-free-en"
                  href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                    i18n.language || "vi"
                  }`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-primary"
                >
                  {t("e-residency.button1")}
                </a>
                {/* <a
                  id="button-why-dokobit-en"
                  href="javascript:;"
                  className="btn-signup btn-dokobit"
                >
                  Why GoPaperless?
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-color p-md-0">
        <div className="container px-md-0">
          <div className="row" id="more-info">
            <div className="col-md-6">
              <img
                src={ic_assignment}
                data-no-retina=""
                alt="ic_assignment"
                className="icon-40"
              />
              <h3>{t("e-residency.note14")}</h3>
              <p>{t("e-residency.note15")}</p>
              <img src={iso} alt="iso" width="150px" />
            </div>
            <div className="col-md-6">
              <img
                className="icon-40"
                src={ic_code}
                data-no-retina=""
                alt="ic_code"
              />
              <h3>{t("e-residency.note16")}</h3>
              <p>{t("e-residency.note17")}</p>
              <a className="btn-signup btn-dokobit" href="/solutions">
                {t("e-residency.button2")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default EResidencyContent;
